import React from 'react';
import type { DocumentationLink } from './DocumentationPDFViewer';
import { cn, Tooltip } from '@thingslog/ui-components';
import { useTranslation } from 'react-i18next';

interface SidebarProps {
  docs: DocumentationLink[];
  currentDocId: number;
  onSelect: (documentId: number) => void;
  className?: string;
}

const DocumentsSideBar: React.FC<SidebarProps> = (props: SidebarProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn('flex min-h-0 flex-col bg-white md:pl-4 text-wrap', props.className)}>
      <div className="flex justify-between w-full py-4 shrink-0">
        <span className="text-lg text-gray-900 font-bold text-wrap max-w-4">
          {t('documentation_title')}
        </span>
      </div>
      <ul className="list-none p-0 flex-1 overflow-y-auto min-h-0">
        {props.docs.map((link: DocumentationLink) => {
          const isActive = props.currentDocId === link.id;
          return (
            <Tooltip title={link.title} placement="right">
              <li
                className={cn(
                  'py-4 px-4 hover:text-gray-900 hover:bg-gray-100 text-gray-400 cursor-pointer',
                  isActive &&
                    'text-gray-900 border-cyan-500 bg-gray-100 border-l-3 border-solid border-t-0 border-r-0 border-b-0'
                )}
                key={link.id}
                onClick={(): void => props.onSelect(link.id)}
              >
                <span className="line-clamp-2">{link.title}</span>
              </li>
            </Tooltip>
          );
        })}
      </ul>
    </div>
  );
};

export default DocumentsSideBar;
